export const CLOSED_POSITION: number = -1;
export const STATUS_IN_PROGRESS: string = "in_progress";
export const STATUS_COMPLETE: string = "complete";
export const POLLING_INTERVAL_MS: number = 5000;
export const OPEN_GETTING_MONITORING_SECTION: number = 1;
export const OPEN_CHECKING_COMPANY_SECTION: number = 2;
export const OPEN_CHECKING_PERSON_SECTION: number = 3;
export const SUBSCRIPTION_WARNING_DAYS: number = 14;
export const COMPANY_TAB: string = "1";
export const SUBSCRIPTION_TAB: string = "2";
export const UPCOMING_TAB: string = "1";
export const PREVIOUS_TAB: string = "2";
export const DESKTOP_BREAKPOINT: number = 768;
export const DOMAIN_MAP: Record<string, string> = {
  "dev.m.biznesguard.ru": "https://dev.biznesguard.ru",
  "m.biznesguard.ru": "https://biznesguard.ru",
};